import { Injectable } from '@angular/core';
import { SettingsService } from '../settings.service';
import { Response } from '@angular/http';
import { Regiao } from '../comum/modelos/regiao';
import { RegiaoCliente } from '../comum/modelos/regiao-cliente';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RegiaoService {

    private _host: string;

    constructor (
        private _settingsService: SettingsService,
        private _http: HttpClient) {
        this._host = this._settingsService.obterHostBase() + '/regioes/';
    }

    obterRegioesHttp(): Observable<Regiao[]> {
        return this._http.get(this._host)
            .catch(this.handleError);
    }

    removerRegiaoHttp(idRegiao: number): Observable<HttpResponse<Regiao>> {
        return this._http.delete(this._host + idRegiao, {
            observe: 'response'
        })
            .catch(this.handleError);
    }

    obterRegiaoPorIdHttp(id: number): Observable<Regiao> {
        return this._http.get(this._host + id)
            .catch(this.handleError);
    }


    cadastrarRegiaoHttp(regiao: Regiao): Observable<HttpResponse<Regiao>> {
        return this._http
            .post(this._host, regiao, {
                observe: 'response'
            })
            .catch(this.handleError);
    }

    atualizarRegiaoHttp(regiao: Regiao): Observable<HttpResponse<Regiao>> {
        return this._http
            .put(this._host, regiao, { responseType: 'text', observe: 'response' })
            .catch(this.handleError);
    }

    obterRegioesClienteHttp(id: number): Observable<RegiaoCliente[]> {

        return this._http.get(this._host + 'cliente/' + id)
            .catch(this.handleError);
    }

    cadastrarRegioesClienteHttp(regiaoCliente: RegiaoCliente[]): Observable<HttpResponse<RegiaoCliente[]>> {
        return this._http
            .post(this._host + 'cliente/', regiaoCliente, {
                observe: 'response'
            })
            .catch(this.handleError);
    }

    removerRegioesClienteHttp(regiaoCliente: RegiaoCliente[]): Observable<HttpResponse<RegiaoCliente[]>> {
        return this._http
            .patch(this._host + 'cliente/', regiaoCliente, {
                observe: 'response'
            })
            .catch(this.handleError);
    }

    obterRegioesTipoPontoFisicoHttp(idsTipoPontoFisico: number[], idsAr: number[]): Observable<RegiaoCliente[]> {
        let idsTpf: string;
        let idsArea: string;

        for (let i = 0, len = idsTipoPontoFisico.length; i < len; i++) {
            if (i === 0) {
                idsTpf = '?idsTpf=' + idsTipoPontoFisico[i];
            } else {
                idsTpf = idsTpf + '&idsTpf=' + idsTipoPontoFisico[i];
            }
        }

        for (let i = 0, len = idsAr.length; i < len; i++) {
            if (i === 0) {
                idsArea = '&idsArea=' + idsAr[i];
            } else {
                idsArea = idsArea + '&idsArea=' + idsAr[i];
            }
        }

        return this._http.get(this._host + 'tipo-ponto-fisico' + idsTpf + idsArea)
            .catch(this.handleError);
    }

    obterRegioesAreaHttp(idsArea: number[]): Observable<RegiaoCliente[]> {
        const params = new URLSearchParams();
        let ids: string;

        for (let i = 0, len = idsArea.length; i < len; i++) {
            if (i === 0) {
                ids = '?id=' + idsArea[i];
            } else {
                ids = ids + '&id=' + idsArea[i];
            }
        }

        params.append('ids', ids.toString());

        return this._http.get(this._host + 'area/' + ids)
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');

    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/regiao/regiao.service.ts